import { AccountsPage } from "./../pages/accounts/accounts";
import { Component, ViewChild, OnInit, OnDestroy } from "@angular/core";
import { Nav, Platform, Menu, PopoverController } from "ionic-angular";
import { Router, ActivatedRoute } from "@angular/router";
import { AngularFireAuth } from "angularfire2/auth";

// Commented out for PWA
// import {StatusBar} from '@ionic-native/status-bar';
// import {SplashScreen} from '@ionic-native/splash-screen';

import { HomePage } from "../pages/home/home";
import { LoginPage } from "../pages/login/login";
import { LoadingPage } from "../pages/loading/loading";
import { MyProfilePage } from "./../pages/my-profile/my-profile";
import { SettingsPage } from "./../pages/settings/settings";
import { ListPage } from "../pages/list/list";
import { RegisterChoosePage } from "../pages/register-choose/register-choose";
import { CreateJobPage } from "./../pages/create-job/create-job";
import { LegalPage } from "./../pages/legal/legal";
import { NotificationsPage } from "./../pages/notifications/notifications";
import { JobPage } from "./../pages/job/job";
import { MyJobsPage } from "./../pages/my-jobs/my-jobs";

import { ProvinceSelectorComponent } from "./../shared/province-selector/province-selector";

import { AuthProvider } from "../providers/auth/auth";
import { NotificationsProvider } from "./../providers/notifications/notifications";

import { IUser } from "../interfaces/users";

@Component({
  templateUrl: "app.html",
})
export class MyApp implements OnInit, OnDestroy {
  @ViewChild(Nav)
  nav: Nav;
  @ViewChild("mainMenu")
  menu: Menu;
  firebaseUser: any;
  authSubscription: any;
  userSubscription: any;
  notificationsSubscription: any;
  unreadNotifications = 0;

  currentUser: IUser;
  userDataLoaded = false;

  rootPage: any = LoadingPage;

  pages: Array<{ title: string; component: any; icon: string }>;
  history;

  currentRoute;

  constructor(
    public platform: Platform,
    private router: Router,
    private route: ActivatedRoute,
    public popoverCtrl: PopoverController,
    private authProvider: AuthProvider,
    private notificationsProvider: NotificationsProvider,
    private afAuth: AngularFireAuth // Commented out for PWA // public statusBar: StatusBar, // public splashScreen: SplashScreen,
  ) {
    // used for an example of ngFor and navigation
    this.pages = [];
    // this.pages = [
    //   { title: "Home", component: HomePage },
    //   { title: "List", component: ListPage }
    // ];

    this.route.url.subscribe((url) => {
      console.log("current url:");
      console.log(url[0].path);
      this.currentRoute = url[0].path;
    });
  }

  ngOnInit() {
    console.log(this.nav["_linker"]["_history"][0]);
    this.history = this.nav["_linker"]["_history"][0];
    this.loadAuth();
    this.initializeApp();
    this.initializeOneSignal();
  }

  ngOnDestroy() {
    console.log("inside ngOnDestroy");
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
    if (this.userSubscription) {
      this.userSubscription.unsubscribe();
    }
    if (this.notificationsSubscription) {
      this.notificationsSubscription.unsubscribe();
    }
  }

  loadAuth() {
    this.authSubscription = this.afAuth.authState.subscribe((fbUser) => {
      if (fbUser) {
        this.firebaseUser = fbUser; // TODO: not sure if i really even need this?
        console.log(fbUser);

        this.authProvider
          .userExists(fbUser.uid)
          .then((result) => {
            console.log("inside result of exists call");
            console.log(result);
            if (result.exists) {
              this.userSubscription = this.authProvider
                .getUserByUid(fbUser.uid)
                .subscribe((user) => {
                  this.currentUser = user;
                  const userType = user["regType"];
                  if (userType === "recruiter") {
                    this.buildRecruiterMenu();
                  } else {
                    this.buildStaffMenu();
                    if (!user.province) {
                      if (
                        this.currentRoute !== "/register-staff" ||
                        this.currentRoute !== "/login"
                      ) {
                        console.log("need to popup province selection modal");
                        this.openProvinceSelector();
                      }
                    }
                  }
                  this.getUnreadNotifications();
                  this.userDataLoaded = true;
                });
              this.updateOneSignal(); // TODO: need to sort something out here

              this.rootPage = HomePage;
            } else {
              this.rootPage = RegisterChoosePage;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        // this.$user.next(null);
        this.rootPage = LoginPage;
        this.menu.swipeEnable(false);
      }
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Commented out for PWA
      // this.statusBar.styleDefault();
      // this.splashScreen.hide();
    });
  }

  initializeOneSignal() {
    const self = this;
    var OneSignal = window["OneSignal"] || [];
    console.log("Init OneSignal");
    OneSignal.push([
      "init",
      {
        appId: "a6710ba1-3d4c-473b-8d42-742545d0c708",
        autoRegister: false,
        allowLocalhostAsSecureOrigin: true,
        notifyButton: {
          enable: false,
        },
      },
    ]);
    console.log("OneSignal Initialized");
  }

  updateOneSignal() {
    const self = this;
    var OneSignal = window["OneSignal"] || [];
    OneSignal.push(function () {
      console.log("Register For Push");
      OneSignal.push(["registerForPushNotifications"]);
    });
    OneSignal.push(function () {
      // Occurs when the user's subscription changes to a new value.
      OneSignal.on("subscriptionChange", function (isSubscribed) {
        console.log("The user's subscription state is now:", isSubscribed);
        OneSignal.getUserId().then(function (userId) {
          console.log("User ID is", userId);
          self.authProvider.updateUserOneSignal(self.firebaseUser.uid, userId);
        });
      });
      // if (this.currentUser !== undefined) {
      //   OneSignal.sendTag('regType', self.currentUser.regType);
      // }
    });
  }

  getUnreadNotifications() {
    this.notificationsSubscription = this.notificationsProvider
      .getUnreadNotifications(this.firebaseUser.uid)
      .subscribe(
        (data) => {
          console.log(data);
          this.unreadNotifications = data.length;
          return data;
        },
        (err) => {
          console.log(err);
        }
      );
  }

  buildRecruiterMenu() {
    this.pages = [];
    const recruiterPages = [
      { title: "Dashboard", component: HomePage, icon: "app-location" },
      { title: "Add Job", component: CreateJobPage, icon: "app-add" },
      { title: "Accounts", component: AccountsPage, icon: "app-wallet" },
      {
        title: "Notifications",
        component: NotificationsPage,
        icon: "app-notifications",
      },
      { title: "Settings", component: SettingsPage, icon: "app-settings" },
      { title: "Legal", component: LegalPage, icon: "app-legal" },
    ];
    recruiterPages.forEach((item) => {
      this.pages.push(item);
    });
  }

  buildStaffMenu() {
    this.pages = [];
    const staffPages = [
      { title: "Dashboard", component: HomePage, icon: "app-location" },
      { title: "My Diary", component: MyJobsPage, icon: "app-diary" },
      {
        title: "Notifications",
        component: NotificationsPage,
        icon: "app-notifications",
      },
      { title: "Settings", component: SettingsPage, icon: "app-settings" },
      { title: "Legal", component: LegalPage, icon: "app-legal" },
    ];
    staffPages.forEach((item) => {
      this.pages.push(item);
    });
  }

  openSettingsPage() {
    this.nav.setRoot(SettingsPage);
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    this.nav.setRoot(page.component);
  }

  openProvinceSelector() {
    console.log("uid from openProvinceSelector");
    console.log(this.currentUser.uid);
    let popover = this.popoverCtrl.create(
      ProvinceSelectorComponent,
      {},
      {
        showBackdrop: true,
        enableBackdropDismiss: false,
        cssClass: "job-popover",
      }
    );
    popover.present();
  }

  logout() {
    console.log("signing out");
    this.userSubscription.unsubscribe();
    this.authSubscription.unsubscribe();
    this.notificationsSubscription.unsubscribe();
    console.log("unsubbed");
    this.afAuth.auth.signOut().then(() => {
      // this.loadAuth();
      console.log("logged out");
      this.rootPage = LoginPage;
      location.reload();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts